import { render } from "./InOnLaysHurt.vue?vue&type=template&id=e50e10d4"
import script from "./InOnLaysHurt.vue?vue&type=script&lang=js"
export * from "./InOnLaysHurt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__